//
// ColumnScroll
//
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
//
// TO CENTER CHILDREN VERTICALLY, WHILE HANDLING
// OVERFLOW Y SCROLLING PROPERLY,
// apply the classname 'my-auto' to them.
//
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
//

import classNames from 'classnames';
import PropTypes from 'prop-types';

import Column from './Column';

function ColumnScroll(props) {
  const {
    className,
    style: incomingStyle = {},
    gap,
    absolute,
    start,
    end,
    between,
    around,
    evenly,
    baseline,
    crossStart,
    crossEnd,
    crossStretch,
    framed,
    framedRed,
    framedButton,
    onClick,
    id,
    onKeyPress,
    children = null,
    padding = 1,
  } = props;

  const finalClassName = classNames(
    'overflow-y-auto',
    className,
  );

  const style = {
    padding: `${4 * padding}px`,
    ...incomingStyle,
  };

  return (
    <Column
      className={finalClassName}
      style={style}
      gap={gap}
      absolute={absolute}
      start={start}
      end={end}
      between={between}
      around={around}
      evenly={evenly}
      baseline={baseline}
      crossStart={crossStart}
      crossEnd={crossEnd}
      crossStretch={crossStretch}
      framed={framed}
      framedRed={framedRed}
      framedButton={framedButton}
      onClick={onClick}
      id={id}
      onKeyPress={onKeyPress}
    >
      {children}

      {/* <div
        className="h-3 w-full shrink-0"
        style={{ marginTop: -gap }}
      /> */}

      <div
        className="absolute sticky h-3 shrink-0 bg-gradient-to-t from-white to-transparent pointer-events-none"
        style={{
          bottom: `-${4 * padding}px`,
          marginLeft: `-${4 * padding}px`,
          width: `calc(100% + ${8 * padding}px)`,
        }}
      />
    </Column>
  );
}

ColumnScroll.propTypes = {
  className: PropTypes.string,
  style: PropTypes.shape({}),
  gap: PropTypes.number,
  absolute: PropTypes.bool,
  framed: PropTypes.bool,
  framedRed: PropTypes.bool,
  framedButton: PropTypes.bool,
  // Alignment along main axis:
  start: PropTypes.bool,
  end: PropTypes.bool,
  between: PropTypes.bool,
  around: PropTypes.bool,
  evenly: PropTypes.bool,
  // Alignment across main axis:
  baseline: PropTypes.bool,
  crossStart: PropTypes.bool,
  crossEnd: PropTypes.bool,
  crossStretch: PropTypes.bool,
  children: PropTypes.node,
  // Optional, define both together:
  id: PropTypes.string,
  onClick: PropTypes.func,
  onKeyPress: PropTypes.func,
  padding: PropTypes.number,
};

export default ColumnScroll;
